import moment, { MomentInput } from 'moment/moment';

export const subtractOffset = (date: MomentInput, utcOffset: number) => {
    return moment(date).subtract(utcOffset, 'minutes');
};
